import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_BOTTOM_SHEET_DEFAULT_OPTIONS } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UIRouterModule } from '@uirouter/angular';
import { AuthModule } from '../auth/auth.module';
import { ComponentsModule } from '../components/components.module';
import { RvBadgeComponent } from '../components/rv-badge/rv-badge.component';
import { SharedModule } from '../shared/shared.module';
import { routes } from './app-common.routes';
import { AppComponent } from './components/app/app.component';
import { AuthButtonsComponent } from './components/auth-buttons/auth-buttons.component';
import { CommonHeaderComponent } from './components/common-header/common-header.component';
import { HelpWidgetButtonComponent } from './components/help-widget-button/help-widget-button.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { PastDueBannerComponent } from './components/past-due-banner/past-due-banner.component';
import { PlanBannerComponent } from './components/plan-banner/plan-banner.component';
import { SelectCompanyComponent } from './components/select-company/select-company.component';
import { SelectCompanyTreeComponent } from './components/select-company-tree/select-company-tree.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ViewportComponent } from './viewport/viewport.component';
import { AccessibilityModule } from '../accessibility';
import { TemplateEditorToolbarComponent } from '../template-editor/components/template-editor-toolbar/template-editor-toolbar.component';

@NgModule({
  declarations: [
    AppComponent,
    ViewportComponent,
    SidebarComponent,
    SelectCompanyComponent,
    PageTitleComponent,
    CommonHeaderComponent,
    AuthButtonsComponent,
    HelpWidgetButtonComponent,
    PlanBannerComponent,
  ],
  imports: [
    A11yModule,
    OverlayModule,
    CommonModule,
    SharedModule,
    ComponentsModule,
    RvBadgeComponent,
    AuthModule,
    BrowserAnimationsModule,
    UIRouterModule.forChild(routes),
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatListModule,
    AccessibilityModule,
    TemplateEditorToolbarComponent,
    PastDueBannerComponent,
    SelectCompanyTreeComponent,
  ],
  providers: [
    {
      provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
      useValue: { ariaLabelledBy: 'modal-label', ariaModal: true },
    },
  ],
  exports: [AppComponent],
})
export class AppCommonModule {}
